import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Divider, Form, Input, Row, Space, Table, Popconfirm, InputNumber, Tabs } from 'antd';
import { usePageTitle } from '../../../context/pageTitleContext';
import { menuLinks, notifyMessages, tablePageSize } from '../../../utils/constants';
import { PlusOutlined, DeleteOutlined, SaveOutlined, EditOutlined } from '@ant-design/icons';
import Loader from '../../../components/common/Loader';
import { useLoader } from '../../../context/loaderContext';
import { Link } from 'react-router';


const CustomerOrderItems = ({ rowsData, onEdit, onCreate }) => {
    const { t } = useTranslation();
    const { loading, setLoading, setHasError } = useLoader();

    const handleDelete = (rowId) => {

    };


    const columns = [
        // {
        //     title: 'No.',
        //     dataIndex: 'rowNumber',
        //     width: '20px',
        // },
        {
            title: t('order.item'),
            dataIndex: 'item',
            key: 'item',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.material'),
            dataIndex: 'material', key: 'material',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.orderQuantity'),
            dataIndex: 'orderQuantity', key: 'orderQuantity',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.plant'),
            dataIndex: 'plant',
            key: 'plant',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.poDetails'),
            dataIndex: 'poDetails',
            key: 'poDetails',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.shippingPoint'),
            dataIndex: 'shippingPoint',
            key: 'shippingPoint',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.storageLocation'),
            dataIndex: 'storageLocation',
            key: 'storageLocation',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.hlItem'),
            dataIndex: 'hlItem',
            key: 'hlItem',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.poItem'),
            dataIndex: 'poItem',
            key: 'poItem',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.enteredMaterial'),
            dataIndex: 'enteredMaterial',
            key: 'enteredMaterial',
            showSorterTooltip: false,
            ellipsis: true,
        },
        // {
        //     title: '',
        //     key: 'action1',
        //     width: '30px',
        //     fixed: 'right',
        //     render: (text, record) => (
        //         <Space size="middle">
        //             <EditOutlined onClick={() => onEdit("update", record)} className='editIcon' />
        //         </Space>
        //     ),
        // },
        // {
        //     title: '',
        //     dataIndex: 'action2',
        //     width: '30px',
        //     fixed: 'right',
        //     render: (_, record) =>
        //         <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.id)}>
        //             <DeleteOutlined className='deleteIcon' />
        //         </Popconfirm>
        // },
    ];

    return (
        <div className="customerOrderDetails">
            {rowsData && (
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Table
                            size='small'
                            className='orderItemsTable'
                            columns={columns}
                            dataSource={rowsData}
                            rowKey={obj => obj.orderItemsID}
                            bordered
                            pagination={{
                                pageSize: tablePageSize,
                                showSizeChanger: false
                            }}
                            scroll={{ x: 'max-content' }}
                        />
                    </Col>
                    {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Button style={{ marginRight: 15 }} onClick={onCreate} icon={<PlusOutlined />} type="default" htmlType='submit'>Add row</Button>
                        </Col> */}
                </Row>
            )}
        </div>
    );
}
export default CustomerOrderItems;